/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */
/* istanbul ignore file */
import { Observable, Observer } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConvertBase64URLToImage {

  private generatedImage: string;
  private map = new Map<string, string>();
  private mapSafeResource = new Map<string, SafeResourceUrl>();

  constructor(private domSanitizer: DomSanitizer) {
  }
  sanatizeUrl(generatedImageUrl): SafeResourceUrl
  {
    if (!this.mapSafeResource.has(generatedImageUrl))
    {
      const safeResourceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(generatedImageUrl);
      this.mapSafeResource.set(generatedImageUrl, safeResourceUrl );
      return safeResourceUrl;
    }
    else{
      return this.mapSafeResource.get(generatedImageUrl);
    }

  }

  getGeneratedImage() {
    return this.generatedImage;
  }

  createBlobImageFileAndShow(imageUrl: string): void {
    if (!this.map.has(imageUrl))
    {
      this.dataURItoBlob(imageUrl).subscribe((blob: Blob) => {
        const imageBlob: Blob = blob;
        const imageName: string = this.generateName();
        const imageFile: File = new File([imageBlob], imageName, {
          type: 'image/jpeg'
        });
        this.generatedImage = window.URL.createObjectURL(imageFile);
      });
      this.map.set(imageUrl,  this.generatedImage);
    }
  }

  generateName(): string {
    const date: number = new Date().valueOf();
    let text = '';
    const possibleText =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 5; i++) {
      text += possibleText.charAt(
        Math.floor(Math.random() * possibleText.length)
      );
    }
    // Replace extension according to your media type like this
    return date + '.' + text + '.jpeg';
  }

  dataURItoBlob(dataURI: string): Observable<Blob> {
    return new Observable((observer: Observer<Blob>) => {
      const byteString: string = window.atob(dataURI);
      const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: 'image/jpeg' });
      observer.next(blob);
      observer.complete();
    });
  }

  getImage(imageUrl: string): SafeResourceUrl {
    this.createBlobImageFileAndShow(imageUrl);
    return this.sanatizeUrl(this.map.get(imageUrl));
  }

}
